<template>
    <div>
        <TopProgress ref="topProgress" />

        <div class="clearfix">
            <div v-if="isLoggedIn" class="topbar navbar navbar-default">
                <div class="navbar-header">
                    <div class="navbar-header-wrapper u-flex-center">
                        <router-link :to="{ name: 'home' }" class="link-no-decoration">
                            <h1>{{ trans('page.site-title') }}</h1>
                        </router-link>
                        <div class="navbar-version-label">
                            {{ trans('app.version') }}
                        </div>
                    </div>

                    <div class="navbar-action | u-display--none-portable">
                        <div class="account-block">
                            <img class="account-block__image" src="./assets/icomoon/SVG/user.svg" />
                            <div class="account-block__meta">
                                <span class="account-block__name">{{ user.name }}</span>
                                <span>
                                    <button
                                        :class="{ btn__GhostLogin: originalUser }"
                                        class="btn btn--blue btn--small"
                                        @click="logout"
                                    >
                                        {{ trans('action.logout') }}
                                    </button>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <AccountBlock v-if="isLoggedIn" class="u-display--none-desk" />
            <div class="app" :class="{ app__loggedin: isLoggedIn }">
                <main class="app-main" :class="{ appMain__loggedIn: isLoggedIn }">
                    <AppNotifications />

                    <router-view />
                </main>
            </div>
        </div>
    </div>
</template>

<script>
import { vueTopprogress as TopProgress } from 'vue-top-progress';
import AppNotifications from './components/AppNotifications.vue';
import AccountBlock from './components/AccountBlock.vue';
import WhiteButton from './components/WhiteButton.vue';
import { mapGetters } from 'vuex';

export default {
    components: {
        TopProgress,
        AppNotifications,
        AccountBlock,
        WhiteButton
    },
    metaInfo: {
        title: 'Login',
        titleTemplate: '%s - Klantlogin',
        htmlAttrs: {
            lang: 'nl'
        }
    },
    computed: {
        ...mapGetters({
            isLoggedIn: 'user/isLoggedIn',
            user: 'user/user',
            originalUser: 'user/originalUser'
        })
    }
};
</script>
